import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { Controller } from 'react-hook-form';

import Options from '../../../../helpers/Options';

import cls from '../step7.module.scss';

const isChildrenArr = ['yes', 'no'];
const teamArr = ['persone', 'group'];

function OfferInformation({
  formValues,
  register,
  control,
  errors,
  setTicketForm,
}) {
  const { t } = useTranslation();
  const [isChildren, setIsChildren] = useState([]);
  const [team, setTeam] = useState([]);

  useEffect(() => {
    const isChildrenType = isChildrenArr.map((el) => ({
      value: el,
      label: t(`create.step7.${el}`),
    }));
    const teamType = teamArr.map((el) => ({
      value: el,
      label: t(`create.step7.place.${el}`),
    }));

    setIsChildren(isChildrenType);
    setTeam(teamType);
  }, [t]);
  const { onChange: onChangePlaces, ...restPropsPlaces } = register('places', {
    min: {
      value: 1,
      message: t('form.validate.maxItem2'),
    },
    max: {
      value: 999,
      message: t('form.validate.maxItem2'),
    },
    required: t('form.validate.required'),
  });

  const { onChange: onChangeCashDesk, ...restCashDeskProps } = register(
    'cashDesk',
    {
      required: t('form.validate.required'),
      min: {
        value: 1,
        message: t('form.validate.maxItem2'),
      },
    },
  );

  const { onChange: onChangeReturnDeposit, ...resReturnDepositProps } =
    register('returnDeposit', {
      required: t('form.validate.required'),
      min: {
        value: 1,
        message: t('form.validate.maxItem2'),
      },
    });

  return (
    <div className={`${cls.box_offer} ${cls.box_offer_global}`}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <TextField
            value={formValues?.places}
            error={!!errors.places}
            type="number"
            name="places"
            label={`${t('create.step7.indicate')} *`}
            fullWidth
            autoComplete="on"
            onChange={(e) => {
              setTicketForm({ places: e.target.value });
              onChangePlaces(e);
            }}
            variant="outlined"
            {...restPropsPlaces}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel>{t('create.step7.currency')}</InputLabel>
            <Controller
              render={({ field }) => (
                <Select {...field}>
                  {Options.optionsCurrency().map((el, key) => (
                    <MenuItem value={el.value || ''} button key={key}>
                      {el.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              name="currency"
              defaultValue={formValues?.currency}
              onClick={(e) => {
                setTicketForm({ currency: e.target.value });
              }}
              control={control}
              className={cls.model}
              label={t('create.step7.currency')}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel>{t('event.ticketModeration.isChildTrue')}</InputLabel>
            <Controller
              defaultValue={formValues?.isChildrenAllowed}
              render={({ field }) => (
                <Select {...field}>
                  {isChildren.map((el, key) => (
                    <MenuItem value={el.value || ''} button key={key}>
                      {el.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              name="isChildrenAllowed"
              label={t('event.ticketModeration.isChildTrue')}
              control={control}
              onClick={(e) =>
                setTicketForm({ isChildrenAllowed: e.target.value })
              }
              className={cls.model}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} className={cls.gridLine}>
          <TextField
            style={{ width: '70%' }}
            value={formValues?.cashDesk}
            error={!!errors.cashDesk}
            name="cashDesk"
            type="number"
            label={t('create.step7.boxOffice')}
            onChange={(e) => {
              setTicketForm({
                cashDesk: e.target.value,
              });
              onChangeCashDesk(e);
            }}
            autoComplete="on"
            variant="outlined"
            {...restCashDeskProps}
            helperText={errors?.cashDesk ? errors?.cashDesk.message : ''}
          />

          <FormControl variant="outlined" style={{ width: '30%' }}>
            <Controller
              render={({ field }) => (
                <Select {...field}>
                  {team.map((el, key) => (
                    <MenuItem value={el.value || ''} button key={key}>
                      {el.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              name="cashDeskTeam"
              defaultValue={formValues?.cashDeskTeam}
              control={control}
              onClick={(e) => setTicketForm({ cashDeskTeam: e.target.value })}
              className={cls.model}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            value={formValues?.returnDeposit}
            error={!!errors.returnDeposit}
            style={{ width: '70%' }}
            name="returnDeposit"
            label={t('create.step7.returndeposit')}
            autoComplete="on"
            type="number"
            variant="outlined"
            onChange={(e) => {
              setTicketForm({
                returnDeposit: e.target.value,
              });
              onChangeReturnDeposit(e);
            }}
            {...resReturnDepositProps}
            helperText={
              errors?.returnDeposit ? errors?.returnDeposit.message : ''
            }
          />

          <FormControl variant="outlined" style={{ width: '30%' }}>
            <Controller
              render={({ field }) => (
                <Select {...field}>
                  {team.map((el, key) => (
                    <MenuItem value={el.value || ''} button key={key}>
                      {el.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
              name="returnDepositTeam"
              control={control}
              defaultValue={formValues?.returnDepositTeam}
              onClick={(e) =>
                setTicketForm({ returnDepositTeam: e.target.value })
              }
              className={cls.model}
            />
          </FormControl>
        </Grid>
      </Grid>
    </div>
  );
}
OfferInformation.propTypes = {
  formValues: PropTypes.shape({}).isRequired,
  register: PropTypes.func.isRequired,
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}),
  setTicketForm: PropTypes.func.isRequired,
};
OfferInformation.defaultProps = {
  errors: null,
};
export default OfferInformation;
